export interface PricingTier {
  id: SubscriptionPlan;
  name: string;
  price: number;
  priceUnit?: string;
  description: string;
  features: string[];
  buttonText: string;
  highlighted: boolean;
}

export enum SubscriptionPlan {
  PAY_AS_YOU_GO = 'PAY_AS_YOU_GO',
}
